function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from "react";
import { Form } from "react-bootstrap";
import _ from "lodash";

var PercentWidget = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PercentWidget, _Component);

  function PercentWidget(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = _extends({}, props, {
      value: props.value && props.value * 100
    });
    return _this;
  }

  var _proto = PercentWidget.prototype;

  _proto._handleChange = function _handleChange(event) {
    var digits = this.state.options.digits == undefined ? 2 : this.state.options.digits;
    var value = event.target.value.replace(/[^0-9.]/g, "");
    if (event.type === "blur" && event.target.value) value = parseFloat(value).toFixed(digits);
    this.setState({
      value: value
    });
    this.state.onChange(value / 100);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _$get = _.get(this.props, "schema", {}),
        title = _$get.title;

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Label, null, title), /*#__PURE__*/React.createElement("div", {
      className: "input-group"
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      id: this.props.id,
      className: "form-control percent",
      style: {
        textAlign: "right"
      },
      value: this.state.value,
      required: this.state.required,
      onBlur: function onBlur(event) {
        _this2._handleChange(event);
      },
      onChange: function onChange(event) {
        _this2._handleChange(event);
      },
      disabled: this.state.disabled,
      readOnly: this.state.readonly
    }), /*#__PURE__*/React.createElement("div", {
      className: "input-group-append"
    }, /*#__PURE__*/React.createElement("span", {
      className: "input-group-text"
    }, "%"))));
  };

  return PercentWidget;
}(Component);

export default PercentWidget;